var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQtpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 45,
    viewBox: "0 0 61 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73891 0.96875L0.386719 9.26V44.9909H52.2455L60.5967 36.7002V0.96875H54.8095H8.73891ZM22.7967 8.66844C26.7155 8.66844 29.4661 9.76859 31.0256 11.99C32.6053 14.1884 33.3848 17.5916 33.3848 22.1961C33.3848 25.2303 33.0567 27.6748 32.422 29.5297C31.7644 31.4028 30.7186 32.8292 29.2406 33.807L32.4422 38.9211L28.5216 40.7337L25.1362 35.2133C24.6441 35.3759 23.8636 35.4364 22.7972 35.4364C18.8363 35.4364 16.0659 34.378 14.5069 32.2597C12.9473 30.1409 12.1678 26.78 12.1678 22.2162C12.1678 17.6333 12.9675 14.2311 14.5472 12.0102C16.1269 9.78828 18.8972 8.66797 22.7972 8.66797L22.7967 8.66844ZM38.6995 10.1553H42.8269V15.6355H48.0802V19.1403H42.8269V27.4714C42.8269 29.0206 42.9478 30.0387 43.1737 30.5478C43.3997 31.0569 43.9941 31.302 44.9189 31.302L48.037 31.1792L48.2231 34.4792C46.5197 34.8045 45.2264 34.9677 44.3245 34.9677C42.1687 34.9677 40.6903 34.4787 39.8906 33.5009C39.0905 32.5231 38.6794 30.6702 38.6794 27.9402V19.1614H35.7872V15.6355H38.6995V10.1553ZM22.8183 12.3561C20.437 12.3561 18.7959 13.1305 17.8917 14.698C17.0105 16.2673 16.5586 18.7527 16.5586 22.1961C16.5586 25.618 16.9898 28.0831 17.8514 29.5498C18.7125 31.0166 20.3752 31.7708 22.8178 31.7708C25.2586 31.7708 26.9011 31.0367 27.7631 29.5902C28.605 28.1436 29.0344 25.6789 29.0344 22.2364C29.0344 18.7737 28.6045 16.2673 27.7219 14.698C26.8406 13.1305 25.2183 12.3561 22.8183 12.3561Z",
    fill: "url(#paint0_linear_1159_2619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2619",
    x1: 0.386719,
    y1: 22.9798,
    x2: 60.5967,
    y2: 22.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQtpy);
export default __webpack_public_path__ + "static/media/qtpy.7d6e5c10b016fe5c168f9355ae215729.svg";
export { ForwardRef as ReactComponent };